import React from 'react';
import './Footer.css';

const Footer = (): JSX.Element => {
  return <div className="footer"></div>;
};

export default Footer;
